<template>
  <div class="news-tidal">
    <!-- banner -->
    <div class="banner">
      <img class="bannerImgText" :class="{'act-show':actShow}" src="~@/assets/img/news/new-text.png" alt="" />
      <img class="bannerImg" src="https://voge-resource.vogemotor.com/news-bg.jpg" alt="">
    </div>
    <!-- 导航 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="item.label" :name="item.name" v-for="(item,idx) in baseTabs.list" :key="idx">
        <second-title
          :englithTitle="item.englithTitle"
          :englithA="item.englithA"
          :changname="item.changname"
          :addone="item.addone"
          :addtow="item.addtow"
        ></second-title>
      </el-tab-pane>
    </el-tabs>
    <router-view></router-view>
  </div>
</template>
<script>
import SecondTitle from '@/components/SecondTitle'
export default {
  components:{
    SecondTitle,
  },
  data(){
    return{
      actShow:false,
      isShow:true,
      activeName: localStorage.getItem('actNum')||"trends",
      baseTabs:{
        list:[
          {
            id: 0,
            label: "无极动态",
            name: "trends",
            englithTitle: "oge Events",
            englithA:"V",
            changname:"无极动态",
            addone:"新闻潮汛",
            addtow:"无极动态",
            path:'/trends'
          },
          {
            id: 1,
            label: "最新活动",
            name: "activity",
            englithTitle: "oge Events",
            englithA:"V",
            changname:"最新活动",
            addone:"新闻潮汛",
            addtow:"最新活动",
            path:'/activity'
          },
          {
            id: 2,
            label: "媒体测评",
            name: "appraisal",
            englithTitle: "oge Events",
            englithA:"V",
            changname:"媒体测评",
            addone:"新闻潮汛",
            addtow:"媒体测评",
            path:'/appraisal'
          },
        ]
      }
    }
  },
  created(){
    if (this.$route.path == "/news-tidal") {
      this.$router.push('/trends')
    }
    setTimeout(() => {
      this.actShow = true
    }, 500);
  },
  methods:{
    handleClick(tab, event){
      this.baseTabs.list.forEach((item,idx) => {
        if (tab.index == item.id) {
          this.$router.push(item.path)
          localStorage.setItem('actNum',item.name)
        }
      });
    }
  }
}
</script>

<style lang="scss">
.news-tidal{
  // max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/img/news/bg-1.jpg") no-repeat;
  background-size: cover;
  line-height: 1;
  .banner {
    width: 100%;
    height: 650px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .bannerImgText{
      position:absolute;
      opacity: 0;
      transition: 1.5s;
      bottom: 20px;
      .act-show{
        opacity: 1;
        bottom: 30%;
      }
    }
    .bannerImg {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .el-tabs__nav-wrap::after{
    height: 0px;
  }
  .el-tabs__nav-scroll {
    background-color:#EEC20A ;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-tabs__nav{
      display: flex;
      justify-content: space-between;
      width: 600px;
      .el-tabs__active-bar {
        height: 0px;
      }
      .el-tabs__item{
        padding: 0 20px;
        font-size: 16px;
        color: rgb(255, 255, 255);
      }
      .el-tabs__item.is-active{
        color: #000;
        font-weight: 800;
      }
      .el-tabs__item:hover{
        color: #000;
        font-weight: 800;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news-tidal/news-tidal.vue